import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invalid-user',
  styles: [`
    .icon-align {
      font-size: 50px; 
      display: inline-flex;
      vertical-align: top;
    }
  `], 
  template: `
    <div fxLayout="row wrap" fxLayoutAlign="center center" class="mt-20">
        <div fxFlex="100" fxLayoutAlign="center">
            <h1 style="margin-bottom: 5px; font-size: 50px;">
                <mat-icon color="warn" class="icon-align" [inline]="true">report_problem</mat-icon>Invalid User Setup
            </h1>
        </div>    
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center" class="mt-20">
        <div fxFlex="100" fxLayoutAlign="center">
            <h3>There is an issue with your user setup. Please contact support to use this application.</h3>
        </div>    
    </div>
  `
})
export class InvalidUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
